import { initGA, trackPageView } from 'hooks/analytics'
import useAutoFetchPublicVersion from 'hooks/useAutoFetchPublicVersion'
import { getMetaContent } from 'helpers'
import { getTranslationKey } from 'hooks/usePageTitle'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Outlet, useLocation } from 'react-router-dom'

const BlankLayout = () => {
  const intl = useIntl()
  const location = useLocation()
  useAutoFetchPublicVersion()

  useEffect(() => {
    document.title = `${getMetaContent('og:title')} - ${intl.formatMessage({ id: location.pathname })}`
    const translationKey = getTranslationKey(location.pathname)
    document.title = `PasarMIKRO Business - ${intl.formatMessage({ id: translationKey })}`
    if (!window.GA_INITIALIZED) {
      initGA()
      window.GA_INITIALIZED = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (location) {
      document.title = `${getMetaContent('og:title')} - ${intl.formatMessage({ id: location.pathname })}`
      const translationKey = getTranslationKey(location.pathname)
      document.title = `PasarMIKRO Business - ${intl.formatMessage({ id: translationKey })}`
      trackPageView(location.pathname)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return <Outlet />
}

export default BlankLayout
